var map;
var InfoObj = [];

var icons = {
  hp:{
    icon: 'https://cdn.shopify.com/s/files/1/0505/4087/1873/files/HP_Map_White.png?v=1661801227'
  }
};

var markersOnMap = [
  {
    storecode: 'H11',
    placeName: 'Hush Puppies Metrocentro',
    storeAddress: 'CC Metrocentro, 7a Etapa, Local 232H, San Salvador',
    schedule: 'Domingo a Jueves: 09:00am a 07:00pm<br>Viernes a Sábado: 09:00am a 07:00pm',
    phone: '22776320',
    whatsapp: '72753013',
    page: 'https://g.page/r/CehSwSyUmw0bEBM',
    review: 'https://g.page/r/CehSwSyUmw0bEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.7054468,
      lng: -89.2129637
    }],
    type: 'hp'
  },
  {
    storecode: 'H12',
    placeName: 'Hush Puppies Plaza Mundo',
    storeAddress: 'CC Plaza Mundo, Local 183, 1r Nivel',
    schedule: 'Lunes a Domingo: 09:00am a 08:00pm',
    phone: '22776320',
    whatsapp: '60561036',
    page: 'https://g.page/r/CVoaJMDswMJsEBM',
    review: 'https://g.page/r/CVoaJMDswMJsEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.69832,
      lng: -89.1521101
    }],
    type: 'hp'
  },
  {
    storecode: 'H13',
    placeName: 'Hush Puppies Metrocentro Santa Ana',
    storeAddress: 'CC Metrocentro Santa Ana, locales 124 y 125B',
    schedule: 'Lunes a Domingo: 09:00am a 07:00pm',
    phone: '22237723',
    whatsapp: '72752903',
    page: 'https://g.page/r/Cd5u-Zg24D28EBM',
    review: 'https://g.page/r/Cd5u-Zg24D28EBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.9776507,
      lng: -89.5616825
    }],
    type: 'hp'
  },
  {
    storecode: 'H75',
    placeName: 'Hush Puppies Metrocentro San Miguel',
    storeAddress: 'CC Metrocentro San Miguel, Etapa 19 Local 88 E',
    schedule: 'Lunes a Domingo: 09:00am a 08:00pm',
    phone: '26678683',
    whatsapp: '72809359',
    page: 'https://goo.gl/maps/XDrqBiNySNBdhH649',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.4619344,
      lng: -88.1660729
    }],
    type: 'hp'
  },
  {
    storecode: 'H87',
    placeName: 'Hush Puppies Galerías',
    storeAddress: 'CC Galerías, Local 139, Módulo 2, San Salvador',
    schedule: 'Lunes a Domingo: 10:00am a 07:00pm',
    phone: '22438317',
    whatsapp: '78506961',
    page: 'https://g.page/r/CZtChYlG0N8EEBM',
    review: 'https://g.page/r/CZtChYlG0N8EEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.702282,
      lng: -89.2298839
    }],
    type: 'hp'
  },
  {
    storecode: 'H88',
    placeName: 'Hush Puppies La Gran Vía',
    storeAddress: 'CC La Gran Vía, Local 301-302',
    schedule: 'Lunes a Jueves: 10:00am a 08:00pm<br>Viernes y Sábado: 10:00am a 09:00pm<br>Domingo: 10:00am a 07:00pm',
    phone: '22789823',
    whatsapp: '72856748',
    page: 'https://g.page/r/CdV1DXRG1_poEBM',
    review: 'https://g.page/r/CdV1DXRG1_poEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6775749,
      lng: -89.2544516
    }],
    type: 'hp'
  },
  {
    storecode: 'H89',
    placeName: 'Hush Puppies Multiplaza',
    storeAddress: 'CC Multiplaza, Local C-14, 2do Nivel.',
    schedule: 'Lunes a Domingo: 10:00am a 07:00pm',
    phone: '26678683',
    whatsapp: '79416170',
    page: 'https://goo.gl/maps/KtXLTY8ojPCNrP2J7',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.6789731,
      lng: -89.2488596
    }],
    type: 'hp'
  }
];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 6%"> (503)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 6%"> (503)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 6%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 6%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 15%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat:  13.6775749, lng: -89.2544516};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 15,
    center: {lat:  13.6775749, lng: -89.2544516},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}